import React from "react";
import HeaderTwo from "../../components/header/HeaderTwo";
import ThistoryDetails from "./ThistoryDetails";
import Footer from "../../components/footer/Footer";

function Thistory() {
  return (
    <>
      <HeaderTwo />
      <main>
        <ThistoryDetails />
      </main>
      <Footer />
    </>
  );
}

export default Thistory;
